import { NgModule } from '@angular/core';
import { WorkitemAnswerNextComponent } from './workitem-answer-next.component';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule
  ],
  declarations: [
    WorkitemAnswerNextComponent
  ],
  exports: [
    WorkitemAnswerNextComponent
  ]
})
export class WorkitemAnswerNextModule {}
